import React, { useState } from 'react';
import styles from './MyFollowers.module.sass';
import cn from 'classnames';
import Item from '../Item';
import useBreakpoints from 'hooks/useBreakpoints';

const MyFollowers = ({ className, data }) => {
  const [stylesRef, setStylesRef] = useState(null);
  const breakpoints = [
    ['desktop', Infinity],
    ['mobile', 716],
  ];
  useBreakpoints(stylesRef, breakpoints);

  return (
    <div
      className={cn(styles.container, { [className]: className })}
      ref={x => setStylesRef(x)}
    >
      {data.length > 0 ? (
        <div className={styles.list}>
          {data.map(user => (
            <Item user={user} key={`user_id_${user.id}`} />
          ))}
        </div>
      ) : (
        <p className={styles.info}>
          Jeszcze nikt nie zaobserwował tego użytkownika.
        </p>
      )}
    </div>
  );
};

export default MyFollowers;
